import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { merchantsById } from "../../Merchants";
import PropTypes from "prop-types";
import { Card } from "./Card";
import { Edit, EditErr } from "./Forms/Edit";
import { LOADING_EMUNS } from "../constants";
import { setLoadingState } from "../action";

const Row = styled.tr`
  border: 1px solid #d0d0d0;
  background: ${(props) => (props.index % 2 === 0 ? "#eee" : "")};
  ${(props) => (props.Edit ? "height:80px" : "")};
`;

const DisplayCard = ({ index, card }) => {
  const dispatch = useDispatch();
  const merchants = useSelector(merchantsById);
  const [canEdit, setCanEdit] = useState(false);
  const [myEditCardErr, setMyEditCardErr] = useState({ error: false, msg: "" });
  const updateCardError = useSelector((state) => state.Cart.error.update);
  const myCardLoadingState = useSelector(
    (state) => state.Cart.loading.state[card.id]
  );

  useEffect(() => {
    if (canEdit && myCardLoadingState === LOADING_EMUNS.LOADED) {
      setCanEdit(false);
      dispatch(setLoadingState(card.id, LOADING_EMUNS.DEFAULT));
    }
  }, [canEdit, myCardLoadingState]);

  if (!merchants[card.merchant]) {
    return null;
  }

  if (canEdit) {
    return (
      <>
        <Row index={index} Edit={canEdit}>
          <Edit
            card={card}
            setMyEditCardErr={setMyEditCardErr}
            myEditCardErr={myEditCardErr.error}
            cancelEditing={(e) => {
              setCanEdit(false);
            }}
          />
        </Row>

        {myEditCardErr.error && (
          <Row index={index}>
            <EditErr error={myEditCardErr.msg} />
          </Row>
        )}
        {myCardLoadingState == LOADING_EMUNS.ERROR && (
          <Row index={index}>
            <EditErr error={updateCardError} />
          </Row>
        )}
      </>
    );
  }

  return (
    <Row index={index}>
      <Card
        card={card}
        setCanEdit={(e) => {
          setCanEdit(true);
        }}
      />
    </Row>
  );
};

DisplayCard.propTypes = {
  index: PropTypes.number.isRequired,
  card: PropTypes.object.isRequired,
};

export { DisplayCard };
